<template>
    <div class="side-navbar">
        <div
            v-on:click="closeSideNavbar()"
            class="button text-end"
        >
            <icon name="close"></icon>
        </div>
        <div
            v-if="getApplicationSetting('ipad_employee_present') === '1'"
            v-on:click="closeSideNavbar()"
            class="button"
        >
            <router-link
                class="ps-2 d-flex align-items-center"
                to="/employees"
                active-class="active"
            >
                <icon name="employee" :fontSize="'1.5rem'"></icon>
                <span class="ps-3">Medewerkers</span>
            </router-link>
        </div>
        <div
             v-on:click="closeSideNavbar()"
             class="button"
        >
            <router-link
                class="ps-2 d-flex align-items-center"
                to="/select-group"
            >
                <icon name="switch" :fontSize="'1.5rem'"></icon>
                <span class="ps-3">Andere groep</span>
            </router-link>
        </div>
        <div
            v-on:click="closeSideNavbar()"
            class="button"
        >
            <router-link
                class="ps-2 d-flex align-items-center"
                to="/about"
            >
                <icon name="info" :fontSize="'1.5rem'"></icon>
                <span class="ps-3">Over</span>
            </router-link>
        </div>
        <div
            v-on:click="closeSideNavbar()"
            class="button"
        >
            <router-link
                class="ps-2 d-flex align-items-center"
                to="/logout"
            >
                <icon name="logout" :fontSize="'1.5rem'"></icon>
                <span class="ps-3">Uitloggen</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
    name: 'side-navbar',
    components: {
        Icon
    },
    methods: {
        closeSideNavbar() {
            this.$store.commit('SET_SHOW_SIDE_NAVBAR', false)
        }
    }
}
</script>

<style scoped>
* {
    font-size: 12px;
}

.side-navbar {
    position: fixed;
    top: 0;
    right: 0;
    width: 250px;
    height: 1000%;
    z-index: 1000;
    background: #505761;
    color: #bdc7d4;
}

.button {
    padding: 10px;
    cursor: pointer;
}

.button:hover {
    background: #35383C;
}

.button a {
    text-decoration: none;
    color: #bdc7d4;
}

p {
    margin: 0;
    padding: 20px;
    padding-top: 6px;
}
</style>
